
<template>
  <v-checkbox
    v-model="checked"
    :label="label"
  ></v-checkbox>
</template>

<script>
export default {
  name: 'BooleanFilter',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Checkbox'
    }
  },
  emits: ['update:modelValue'],
  computed: {
    checked: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  }
};
</script>
